import client from '../httpClient';

// 【mokuhyoMst003】キマリス目標更新
const updateKimarisTarget = (targetId, params) => {
  return client.put(`/keymalis-target-settings/${targetId}`, params);
};

export default updateKimarisTarget;
